import { AxiosResponse } from 'axios';
import { TagService } from './tagsService';
import { Tag } from 'src/types/tag';

export interface ApiTags {
    getTags(urlParams: string): Promise<AxiosResponse>;
    deleteTags(data: string[]): Promise<AxiosResponse>;
    getTagById(tagId: string): Promise<AxiosResponse>;
    createTag(tag: Tag): Promise<AxiosResponse>;
    updateTag(tag: Tag): Promise<AxiosResponse>;
}

export const tagService = new TagService();
